import { useContext, useMemo } from "react";
import { ValidityGroupContext } from "./ValidityGroupContext";

/**
 * Indicates whether a parent `ValidityGroup` is currently invalid.
 * @returns A tuple containing a boolean value indicating validity and an error message.
 */
export function useValidity(): [boolean, string | null] {
  const { invalid, error = null } = useContext(ValidityGroupContext);
  return useMemo(() => [invalid, error], [invalid, error]);
}
